module.exports = __webpack_public_path__ + "assets/media/discover_image.2b20a8ff.jpg";